module.exports = "/images/vendor/flag-icon-css/flags/1x1/af.svg?fa735e43100e6ba7d02afc2d27ff088c";